import type { Components, Theme } from '@mui/material';

export const MuiMenuItem: Components<Theme>['MuiMenuItem'] = {
  styleOverrides: {
    root: () => ({
      '&.MuiMenuItem-root': {},
      fontSize: '1.4rem',
    }),
  },
};
